import { FC } from 'react';

import voucherBrownIcon from '@/assets/voucherBrownIcon.png';
import voucherGreenIcon from '@/assets/voucherGreenIcon.png';
import voucherRedIcon from '@/assets/voucherRedIcon.png';

type StatCardProps = {
  title: string;
  count: number;
  variant: 'purchased' | 'active' | 'redeemed';
};

const STAT_CONFIG = {
  purchased: {
    icon: voucherBrownIcon,
    textColor: 'text-secondary-300',
    subtitle: 'Vouchers purchased',
  },
  active: {
    icon: voucherGreenIcon,
    textColor: 'text-vouchersGreen',
    subtitle: 'Active Vouchers',
  },
  redeemed: {
    icon: voucherRedIcon,
    textColor: 'text-vouchersRed',
    subtitle: 'Redeemed Vouchers',
  },
} as const;

const StatCard: FC<StatCardProps> = ({ title, count, variant }) => {
  const config = STAT_CONFIG[variant];

  return (
    <div className="bg-white rounded-lg shadow-sm p-6 border border-gray-200">
      <div className="flex items-center gap-4">
        <div className="flex-shrink-0">
          <img src={config.icon} alt={title} className="w-7 h-5" />
        </div>
        <div className="flex-1">
          <p className="text-sm font-semibold text-gray-900">{title}</p>
          <p className="text-xs text-gray-500">{config.subtitle}</p>
        </div>
        <div className="flex-shrink-0">
          <p className={`text-4xl font-bold ${config.textColor}`}>{count}</p>
        </div>
      </div>
    </div>
  );
};

export default StatCard;
